import Button from '../../../components/ui/button/Button';
import { ReactComponent as LeftArrow } from '../../../images/left-arrow.svg';
import { ReactComponent as CloseIcon } from '../../../images/close-btn.svg';

export type PdfViewerHeadlineProps = {
  isFromPdfViewerPage: boolean;
  isMobileWidth: boolean;
  isInitialized: boolean;
  isFlagsMobileViewOpen: boolean;
  onClosePdfViewer: () => void;
  setIsFlagsMobileViewOpen: (isOpen: boolean) => void;
};

export function PdfViewerHeadline({
  isFromPdfViewerPage,
  isMobileWidth,
  isInitialized,
  isFlagsMobileViewOpen,
  onClosePdfViewer,
  setIsFlagsMobileViewOpen
}: PdfViewerHeadlineProps) {
  const renderBackToDocumentsButton = () => (
    <Button
      bgcolor="#2a906e"
      color="white"
      radius="8px"
      style={{ fontSize: 16 }}
      onClick={() => {
        if (isMobileWidth) {
          onClosePdfViewer();
        }
      }}
    >
      Back to Documents
    </Button>
  );

  const renderShowFlagsButton = () => (
    <button
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 16,
        backgroundColor: !isFlagsMobileViewOpen ? 'var(--color-ai-green)' : '#222',
        color: 'white',
        borderRadius: '8px',
        padding: '4px 20px',
        outline: 'none !important',
        border: 'none',
        cursor: 'pointer'
      }}
      onClick={() => setIsFlagsMobileViewOpen(!isFlagsMobileViewOpen)}
    >
      <span
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          alignContent: 'stretch',
          gap: '12px'
        }}
      >
        {isFlagsMobileViewOpen
            ? <span>
              <CloseIcon
              fill="#7d7d7f"
              height="20px"
            />
            </span>
            : <span><LeftArrow fill="white" width="12px" height="12px" /> Show Flags</span>
        }
             {/* {isNotesMobileViewOpen 
            ? <span>Hide Flags <LeftArrow fill="white" width="12px" height="12px" style={{ transform: 'scaleX(-1)' }}  /></span>
            : <span><LeftArrow fill="white" width="12px" height="12px" /> Show Flags</span>
        } */}
      </span>
     
    </button>
  );

  // pdf-viewer page headline
  if (isFromPdfViewerPage && isMobileWidth) {
    return (
      <>
        {isInitialized && (
          <div
            style={{
              position: 'absolute',
              top: isFlagsMobileViewOpen ? '51vh' : '50px',
              right: isFlagsMobileViewOpen ? '24px' : '8px',
              zIndex: 9999,
              transition: 'top 160ms ease-out'
            }}
          >
            {renderShowFlagsButton()}
          </div>
        )}
      </>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: isFromPdfViewerPage ? 'flex-end' : 'space-between',
        alignItems: 'center',
        alignContent: 'stretch',
        padding: '12px 8px'
      }}
    >
      {!isFromPdfViewerPage && renderBackToDocumentsButton()}

      {renderShowFlagsButton()}
    </div>
  );
}
